import React from 'react';
import {Button, Input, message, Modal, Spin, Upload, Icon} from "antd";
import StuffCard from "./stuffCard";
import {base64Encode, uuid} from "../../../utils";
import {
    saveStatusName,
    savePicAndArt,
    publishPicAndArt,
} from "../../../actions/weiChat";
import ChooseUserModal from "../../../containers/chooseUserModal";
import WeiChatTagSelect from "../../../containers/weiChatTagSelect";
import {Scrollbars} from "react-custom-scrollbars";
import SelectPictureOrArticle from "../../../components/resource-list/selectPictureOrArticle"
import {connect} from "react-redux";
import SelectManuscriptPool from '../manuscriptPool/SelectManuscriptPool'
import Editors from '../../components/editor/Editors'
import Activiti from "../../../components/activityNew/ActivityFlow";
import $ from 'jquery';
import BaseComponent from "../../../base/BaseComponent";
import ActivitiModal from "../../editor/components/activitiAndBtn/ActivitiModal";
import ImgChoose from "../../editor/components/editContentChoose/ImgChoose";
import LinkCheck from "../../editor/components/pluginsSpace/linkCheck/linkCheck"
import {PIC_TYPE,PIC_TYPE_ORIGINAL,PIC_TYPE_WECHAT,PIC_TYPE_ORIGINAL_WECHAT} from "../../../constants";
import SyncModal from "../syncModal/syncModal";
import SecurityCheck, {
    addContentSecurityByText,
    formatItem,
    removeContentSecurity
} from "../../mediaRelease/component/securityCheck/securityCheck";

const {TextArea} = Input;
const {confirm} = Modal;
const postMessageDoMain = 'https://xiumi.us/';
/** 节点数据 **/
let actTask = {
    lastId: null    //最后一个节点id，也就是当前所流转到的节点id
};

let mediaRoleColum = {};

var activitiType_G = "DEFAULT";

function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
}

function beforeUpload(file) {
    let imgType=PIC_TYPE_WECHAT;
    let imgarr=file.type.split('/')
    let isJpgOrPng =  imgType.some(item=>item==imgarr[imgarr.length-1])
    // const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
        message.error('仅支持jpg、png等常见图片格式!');
    }
    const isLt2M = file.size / 1024 / 1024 < 10;
    if (!isLt2M) {
        message.error('图片限制最大10M！');
    }
    return isJpgOrPng && isLt2M;
}

class EditMaterial extends BaseComponent {

    currentUser;

    publishTagId = 0;

    textareaModalTitle = '备注';

    callbackType = '';

    callback = () => {
    };

    constructor(props) {
        super(props);
        this.state = {
            stuffList: [],
            btns: [],
            bthAll: [],
            mediaId: props.mediaId,
            materialId: props.materialId,
            visible: false,
            statusName: "",
            loading: false,
            publishModalVisible: false,     // 发布时选择标签框
            textareaModalVisible: false,    // 撤回的备注框
            // isEditMaterial:props.isEditMaterial,
            // edit: props.edit
            remarksContent: "",
            currentItem: {},
            currentItemIndex: 0,
            title: '',
            author: '',
            titlePic: '',
            summary: '',
            content: '',
            storyId:'',
            isUpDate: false,
            scrollDown: false,
            xiuMiStatus: false,
            xiuMiUrl: '',
            xiumiId: '',
            url: '',
            isAdd: false,//是否点击微信发布的添加按钮添加的。
            showRemarkBtnStyle: 'block',
            imgAll:[],
            activityBtnKey: uuid()
        };
    }

    componentWillMount() {
        if(window.innerWidth <= this.allWidth.width) {
            this.allWidth = {
                width: 1325,
                leftW: 400,
                contentW: 620,
                rightW: 305
            };
        }
        this.initActivitiConfig({});
    }

    /**
    * 设置流程配置
    * */
    initActivitiConfig(currentMaterial) {
        let that = this;
        let account = (window.currentUser && window.currentUser.account) ? window.currentUser.account : "";
        let canDo = true;
        let id = (that.state.materialId && that.state.materialId.length>1 && that.state.materialId!='undefined' && that.state.materialId != 'null') ? that.state.materialId : "";
        let publishBtnShowStatus = this.sysConfigGetValueByKey("WeChat.show.publishBtn.status", "已发布");
        let mustNotShowPublishBtn = (currentMaterial.statusName && publishBtnShowStatus.indexOf(currentMaterial.statusName)>-1)?false:true;
        this.state.activityOption = {
            id: id,//流程id
            activitiConf: {
                type: "activitiTreeRoot-weixin",
            },//流程conf,//流程conf
            pojoName: 'material',//数据表name
            userAccount: account,//当前用户account
            showBtnFlag: true,//是否显示流程按钮
            againFlag: (currentMaterial && currentMaterial.statusName == "草稿"),//重置流程的判断条件
            showAfterFuns: {

                //撤回按钮显示前置js
                callBackBtnShow: function (item, call) {
                    //不允许编辑
                    canDo = false;
                    call({code: 1});
                },
                publishCheck: function (item, call) {
                    if (mediaRoleColum.publish) {
                        call({code: 1, log: "拥有发布权限"});
                    } else {
                        call({code: 0, log: "未拥有发布权限"})
                    }
                },
                //弃用按钮显示前置js
                abandon: function (item, call) {
                    if (id) {
                        call({code: 1, log: "拥有弃用权限"});
                    } else {
                        call({code: 0, log: "未拥有弃用权限"})
                    }
                },
            },//流程按钮加载前置js
            getTextRequisite: false,//备注是否必填
            otherJs: {
                callActRevert: function (activiti, buttonConf, call) {
                    activiti.terminate.call(activiti, function (res) {
                        if (res == true) {
                            activiti.options.statusNameTemp = "草稿";
                            // //如果是约稿的撤稿，需要修改 约稿人的 状态；
                            // that.callBackTxyStatus();
                            activiti.endFunction(activiti, function (res) {
                                if (res) {
                                    message.success("流程已撤回，稿件变为草稿状态", 1, function () {
                                        activiti.submitOK();
                                    });
                                }
                            })
                        }
                    });
                },
                /**
                 * 选择我自己
                 * @param activiti
                 * @param buttonConf
                 * @param call
                 */
                chooseMe: function (activiti, buttonConf, call) {
                    let userInfo = window.top.currentUser;
                    activiti.options._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS = [{
                        id: userInfo.account,
                        name: userInfo.name
                    }];
                    call({code: 1, log: "chooseMe：下一流程 流转至当前用户！"});
                },
                callBackSubmiiter: function (activiti, buttonConf, call) {
                    that.callBackSubmiiter.call(that, activiti, buttonConf, call);
                    call({code: 1, log: "callBackSubmiiter"});
                },
                callPublish: function (activiti, buttonConf, call) {
                    if (!that.state.stuffList || that.state.stuffList.length === 0) {
                        message.warn("请至少添加一个图文");
                        that.setState({
                            loading: false
                        });
                        return;
                    }
                    call({code: 1, log: "callPublish"});
                    // that.setState({
                    //     publishModalVisible: true
                    // });
                    // that.callback = call;
                    // that.isActPublish = true;
                },
            },//流程按钮点击事件前置js
            btnColor: this.themeBgColor,
            saveFunction: that.saveMaterial,//稿件保存方法
            publish: that.publishMaterial,
            saveStatusNameFunction: that.updateStatusName,//稿件改流程状态方法
            onSubmitOK: function (activiti) {
                that.props.onAdvance();
            },//流程事件运行完毕的回调
            successCall: () => {
            },//流程加载完的回调
            readyCall: () => {
            },//流程初始化完的回调
            onlyShowBtn: true,//是否只返回流程按钮
            title: '',//流程弹窗title
            visible: false,//流程弹窗是否展示
            btnLoadOver:(btns)=>{
                this.activitiBtns = btns;
                this.setState({});
            },
            btnType: "primary",
            showBtnIcon: false,
            showRemarks: (remarks) => {
                if(remarks && remarks.length) {
                    this.setState({showRemarks:true,remarks})
                }
            },//备注回显
            mustNotShowPublishBtn,
            chooseFilterObject: function (users, call) {
                if (!users || users.length < 1) {
                    call && call(users);
                    return false
                }
                let mediaInfo = {mediaId:that.props.mediaId};
                if(!mediaInfo) {
                    message.warning("过滤媒体权限失败，请先选择主栏目");
                    window.loading.hide();
                    return false
                }
                let receivers = users.map(item=>({
                    deptId: item.deptData[0]._id,
                    userId: item._id,
                }));
                that.request({
                    url: "/cm-sites-pms/contribute/filterUser",
                    method: "post",
                    contentType: "json",
                    body: {
                        mediaInfo,
                        receivers
                    },
                    callBack: (list) => {
                        let newUsers = [];
                        if(list&&list.length) {
                            newUsers = list
                            call && call(newUsers)
                        } else {
                            message.warning("未查到拥有媒体权限的待办用户");
                            window.loading.hide();
                        }

                    },
                    errorCallBack: () => {
                        this.error("过滤媒体权限失败,请稍后重试");
                        window.loading.hide();
                    },
                });
            },
            checkForm: that.checkForm
        };
    }

    componentDidMount() {
        if(this.urlParams?.stuffList?.length) {
            this.synthesizer(this.urlParams.stuffList);
        } else {
            this.loadMaterial();
        }
    }

    componentWillUnmount() {
        //卸载监听
        this.setState = (state, callback) => {
            return;
        };
    }

    allWidth = {
        width: 500+700+416,
        leftW: 500,
        contentW: 700,
        rightW: 416
    };
    render() {
        return (
            <div>
                <Spin spinning={this.state.loading}>
                    <div style={{display: 'flex', flexDirection: 'column'}}>
                        <div style={{display: 'flex'}}>
                            <div style={{width:this.allWidth.leftW+this.allWidth.contentW,display: 'flex'}}>
                                {this.renderLeft(this.allWidth.leftW)}
                                {this.renderRight(this.allWidth.contentW)}
                            </div>
                            {
                                this.countItem > 0 ? this.renderCheckResult(this.allWidth.rightW) : ""
                            }
                        </div>
                        {this.renderFooter()}
                    </div>
                </Spin>
                {this.renderModal()}
                <LinkCheck ref={(LinkCheck)=>{this.LinkCheck=LinkCheck}}/>
                <SecurityCheck ref={ref=>this.securityCheck=ref} noInfoCheckRecord={this.state.noInfoCheckRecord}/>
            </div>
        );
    }
    renderLeft = (width) => {
        let height = 750; //window.$(window).height() * 0.8;
        let btnHeight = 55;
        let contentHeight = height - btnHeight;
        let newSecondSelectColor = this.themeBgColor;
        //是否显示关联选题按钮
        let chooseTopicBtn = this.sysConfigGetValueByKey("pms.weChatPublish.chooseTopic", '0');
        if (chooseTopicBtn === '0') {
            chooseTopicBtn = false;
        } else {
            chooseTopicBtn = true
        }
        return (
            <div style={{width: width}}>
                <Scrollbars>
                    <div style={{padding: '24px 0px 24px 24px'}}>
                        <div style={{width: width-400+300}}>
                            <StuffCard
                                isEditMaterial={true}
                                stuffList={this.state.stuffList}
                                checkData={this.checkData}
                                openCheckedMode={true}
                                isAdd={this.state.isAdd}
                                chooseTopicBtn={chooseTopicBtn}
                                canEdit={this.canEdit}
                                delStuff={this.delStuff.bind(this)}
                                isMerge={true}
                                ref={"stuffCard"}
                                upStuff={this.upStuff.bind(this)}
                                downStuff={this.downStuff.bind(this)}
                                reloadStuff={this.reloadStuff.bind(this)}
                                itemClick={(item, index) => {
                                    this.itemClick(item, index)
                                }}
                                id={this.props.materialId}
                                contentHeight={contentHeight}
                                relation={() => this.relation()}
                                currentIndex={this.state.currentItemIndex}
                                currentItem={this.state.currentItem}
                                isOpenEditAttr={true}
                                addPic={() => {
                                    this.addPic()
                                }}
                                choosePic={() => {
                                    this.SelectPictureOrArticle.changeVisible(true)
                                }}
                                statusName={this.state.statusName}
                                newSecondSelectColor={newSecondSelectColor}
                            />
                        </div>
                    </div>
                </Scrollbars>
                {/* 创建图文*/}
                {/*<AddTopic ref={(AddTopic) => {*/}
                {/*    this.AddTopic = AddTopic*/}
                {/*}} callBack={(id) =>*/}
                {/*    this.createTopic(id)*/}
                {/*}/>*/}
                {/*选择图文*/}
                <SelectPictureOrArticle
                    newSecondSelectColor={newSecondSelectColor}
                    mediaCode={this.props.mediaId}
                    ref={(SelectPictureOrArticle) => {
                        this.SelectPictureOrArticle = SelectPictureOrArticle
                    }} callBack={(selectItem) => {
                    this.chooseTopic(selectItem);
                }}/>
                <SelectManuscriptPool
                    newSecondSelectColor={newSecondSelectColor}
                    ref={(SelectManuscriptPool) => {
                        this.SelectManuscriptPool = SelectManuscriptPool
                    }}
                    callBack={(data) => {
                        let stuffList = this.state.stuffList;
                        stuffList[this.state.currentItemIndex].topicName = data.tsName || '';
                        stuffList[this.state.currentItemIndex].topicId = data.id || '';
                        this.setState({
                            stuffList
                        })
                    }}/>
            </div>
        )
    };
    renderRight = (width) => {
        let height = 750; //window.$(window).height() * 0.8;
        let btnHeight = 55;
        let contentHeight = height - btnHeight;
        const uploadButton = (
            <div>
                <Icon type={this.state.loading ? 'loading' : 'plus'}/>
                <div className="ant-upload-text">上传封面</div>
            </div>
        );
        const {titlePic,imgAll} = this.state;
        //是否显示关联选题按钮
        let btnShow135 = false;
        let btnShow135status = this.sysConfigGetValueByKey("pms.wechat.135btn", '0');
        if (btnShow135status === '1') {
            btnShow135 = true;
        }
        let materialSummaryMaxLength = this.sysConfigGetValueByKey("material.summary.max.length", "120")*1;
        return (
            this.state.stuffList.length > 0 ? <div style={{
                width: width,
                paddingLeft: 2,
                height: contentHeight,
                paddingRight: 20
            }}>
                <div style={{height: '100%',borderLeft:"1px solid rgba(0, 0, 0, 0.15)",paddingLeft: '27px'}}>
                    <div style={{paddingTop: 20,paddingRight:10,position:"relative"}}>
                        <div style={{width: '100%'}}><Input
                            style={{fontSize: 18, color: '#a4adc8', height: 45,borderRadius:5,background:"#f6f8fd",border:"1px solid #eef2fb",paddingRight:70}}
                            maxLength={64}
                            value={this.state.title}
                            onChange={(e) => {
                                this.onChangeByCheck();
                                if (this.state.stuffList.length > 0) {
                                    this.state.stuffList[this.state.currentItemIndex].title = e.target.value;
                                }
                                this.setState({title: e.target.value})
                            }}
                            placeholder="请在这里输入标题"/></div>
                        <div style={{
                            height: 32,
                            width:66,
                            textAlign:"center",
                            lineHeight: '32px',
                            position:"absolute",
                            top:"50%",
                            right:13,
                            background:"#f6f8fd",
                            marginTop:"-7px",
                            color: '#a4adc8'
                        }}>{this.state.title && this.state.title.length ? this.state.title.length : 0}/64
                        </div>
                    </div>
                    <Scrollbars style={{paddingRight: '10px', height: 'calc( 100% - 65px)'}}
                                ref={(scrollRef) => {
                                    this.scrollRef = scrollRef
                                }}  /*onScroll={this.onScroll}*/ >
                        <div className={'scrollDown'} style={{
                            display: this.state.scrollDown ? 'none' : 'block',
                            paddingRight: '10px'
                        }}>
                            <div style={{position:"relative", paddingTop: 20}}>
                                <div style={{width: '100%'}}><Input
                                    style={{fontSize: 14, color: '#a4adc8',borderRadius: 5,background: "#f6f8fd",border: "1px solid #eef2fb"}}
                                    maxLength={8}
                                    value={this.state.author}
                                    onChange={(e) => {
                                        if (this.state.stuffList.length > 0) {
                                            this.state.stuffList[this.state.currentItemIndex].author = e.target.value;
                                        }
                                        this.setState({author: e.target.value})
                                    }}
                                    placeholder="请输入作者"/></div>
                                <div style={{
                                    position:"absolute",
                                    top:"50%",
                                    right:26,
                                    background:"#f6f8fd",
                                    color: '#a4adc8'
                                }}>{this.state.author && this.state.author.length ? this.state.author.length : 0}/8
                                </div>
                            </div>
                            <div style={{display: 'flex', paddingTop: 20}}>
                                <div className={'uploadCover'}>
                                    <Upload
                                        accept={"."+PIC_TYPE_ORIGINAL_WECHAT.join(",.")}
                                        name="file"
                                        listType="picture-card"
                                        className="avatar-uploader"
                                        showUploadList={false}
                                        action="/storage/uploadFile"
                                        beforeUpload={beforeUpload}
                                        onChange={this.handleChange.bind(this)}
                                    >
                                        {titlePic ? <img src={titlePic} alt="avatar" style={{
                                            width: '103px',
                                            height: '103px',
                                            objectFit: 'cover'
                                        }}/> : uploadButton}
                                    </Upload>
                                    <style>{`   
                                    .uploadCover .ant-upload.ant-upload-select-picture-card > .ant-upload{
                                        padding:0;
                                    }
                                    .uploadCover .ant-upload.ant-upload-select-picture-card > .ant-upload{
                                        width:104px;
                                        height:104px;
                                        background:rgba(0, 80, 179, 0.04);
                                    }
                                    `}</style>
                                </div>
                                <div style={{height: 32, lineHeight: '32px', width: '100%',position:'relative'}}>
                                    <TextArea
                                        placeholder={'选填，摘要会在订阅号消息，转发链接等文章外的场景显露，帮助读者快速了解内容，如不填写则首次创建时默认抓取正文前54文字'}
                                        rows={2}
                                        style={{
                                            width: '100%',
                                            fontSize: 14,
                                            height: 104,
                                            resize: 'none',
                                            zIndex:1,
                                            background:'rgba(0, 80, 179, 0.04)'
                                        }}
                                        maxLength={materialSummaryMaxLength}
                                        value={this.state.summary ? this.state.summary.slice(0, materialSummaryMaxLength) : ""}
                                        onChange={(e) => {
                                            this.onChangeByCheck();
                                            if (this.state.stuffList.length > 0) {
                                                this.state.stuffList[this.state.currentItemIndex].summary = e.target.value;
                                            }
                                            this.setState({summary: e.target.value})
                                        }}
                                    />
                                    <div style={{
                                        textAlign: 'right',
                                        // paddingRight: 20,
                                        color: '#a4adc8',
                                        marginTop: '-20px',
                                        zIndex: 999,
                                        position: 'absolute',
                                        top:90,
                                        right:20,
                                    }}>{this.state.summary && this.state.summary.length ? this.state.summary.slice(0, materialSummaryMaxLength).length : 0}/{materialSummaryMaxLength}
                                    </div>
                                </div>
                            </div>
                            <div  style={{
                                alignSelf: "flex-end",
                                color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3"),
                                fontSize: "12px",
                                marginLeft: '30px',
                                marginTop:'-10px',
                                marginBottom:16
                            }}>
                                <span style={{cursor: "pointer",}} onClick={() => {
                                    this.contentChoose();
                                }}>正文选择</span>
                            </div>
                            <div style={{
                                width: '100%',
                                paddingRight: 3,
                                paddingBottom: 10
                            }}><Input
                                style={{fontSize: 14, color: 'rgba(0, 0, 0, 0.45)', border: '1px solid #eef2fb',background: "#f6f8fd",borderRadius: 5}}
                                /*  maxLength={8}*/
                                value={this.state.url}
                                onChange={(e) => {
                                    if (this.state.stuffList.length > 0) {
                                        this.state.stuffList[this.state.currentItemIndex].url = e.target.value;
                                    }
                                    this.setState({url: e.target.value})
                                }}
                                placeholder="请输入原文链接"/></div>
                        </div>
                        <div className={'weChatEdit'} style={{paddingRight: '10px'}}>
                            <Editors
                                content={this.state.content}
                                isUpDate={this.state.isUpDate}
                                imgBtnShow={true}
                                xiuMiBtnShow={true}
                                xiuMiPlugInBtnShow={true}
                                btnShow135={btnShow135}
                                wechatImgWidth={true}
                                currentItemIndex={this.state.currentItemIndex || 0}
                                materialId={this.state.materialId}
                                stuffId={this.state.stuffList[this.state.currentItemIndex] && this.state.stuffList[this.state.currentItemIndex].fromId ? this.state.stuffList[this.state.currentItemIndex].fromId : 0}
                                xiumiIdCallBack={(id) => {
                                    console.log('秀米id', id);
                                    this.state.stuffList[this.state.currentItemIndex].fromId = id;
                                    let params = {
                                        id: this.state.materialId,
                                        mediaId: this.props.mediaId,
                                        stuffList: this.state.stuffList,
                                        isAdd: this.state.isAdd
                                    };
                                    savePicAndArt(params, (res) => {
                                        if (res && res.data && res.data.id) {
                                            this.state.stuffList[this.state.currentItemIndex].id = res.data.stuffList[this.state.currentItemIndex].id;
                                            this.state.stuffList.forEach(item => {
                                                item.materialId = res.data.id;
                                            });//给每一条stuff数据都加上materialId
                                            this.setState({materialId: res.id})
                                        }
                                        console.log('秀米返回数据保存')
                                    });
                                    this.setState({})
                                }}
                                title={this.state.title}
                                callBackeditorContent={(data, text) => {
                                    if(!this.state.isUpDate && this.state.content!==data) {
                                        this.onChangeByCheck();
                                    }
                                    if (this.state.stuffList.length > 0) {
                                        this.state.stuffList[this.state.currentItemIndex].content = data;
                                    }
                                    // console.log("text",text);
                                    this.state.stuffList[this.state.currentItemIndex].text = text.replace(/[\r\n]/g, "").replace(/\ +/g, "").replace(/&nbsp;/g,"");
                                    this.setState({content: data, isUpDate: false})
                                }}
                            />
                            <style>{`
                                .weChatEdit .w-e-text{
                                    background:rgba(0, 80, 179, 0.04);
                                }
                            `}</style>
                        </div>
                    </Scrollbars>
                </div>
                {/*正文选择*/}
                <ImgChoose getImgChoose={(data)=>this.getImgChoose(data)} imgAll={imgAll} ref={e=>this.imgChoose=e}/>
            </div> : <div style={{
                width: 'calc( 100% - 500px )',
                paddingLeft: '10px',
                height: contentHeight,
                paddingRight: 20
            }}></div>
        )
    };
    renderCheckResult = (width) => {
        let {checkKey} = this.state;
        let SENSITIVE = 0;
        let OUTSIDE_CHAIN = 0;
        let config = [
            {
                name: "标题区域",
                key: "title_"+checkKey,
                checkList: []
            },
            {
                name: "摘要区域",
                key: "summary_"+checkKey,
                checkList: []
            },
            {
                name: "正文区域",
                key: "content_"+checkKey,
                checkList: []
            },
        ];
        for(let i in this.checkDataItem) {
            let item = this.checkDataItem[i];
            if(item?.length) {
                for(let k=0;k<item.length;k++) {
                    let Item = item[k];
                    if(Item?.category === "OUTSIDE_CHAIN") {
                        OUTSIDE_CHAIN++
                    } else {
                        SENSITIVE++
                    }
                    let find = config.find(item=>item.key===i);
                    if(find?.checkList?.push) {
                        find.checkList.push(formatItem(Item))
                    }
                }
            }
        }
        return (
            <div style={{
                display: "flex",
                width:width,
                flexDirection: "column",
                height: 695,
                borderLeft: "1px solid #e8e8e8",
                fontSize:12,
            }}>
                <div style={{flex:1,height: 516,padding: 24}}>
                    <Scrollbars style={{height: "100%",width:"100%"}}>
                        <div title={"统计区"} style={{padding:12,background:"#fff9f9",height:91,border: "1px solid #fee",fontSize:14,borderRadius: "5px"}}>
                            <div>当前图文</div>
                            <div>敏感信息：<span style={{color:"red"}}>{SENSITIVE}</span> 条</div>
                            <div>疑似外链：<span style={{color:"blue"}}>{OUTSIDE_CHAIN}</span> 条</div>
                        </div>
                        {
                            config.map(item=>{
                                if(item.checkList?.length) {
                                    return (
                                        <div title={item?.name} style={{marginTop:16}}>
                                            <div style={{width: width-416+367,height: 32,display: "flex",alignItems: "center",paddingLeft: 8,background: "#ebf1f9",fontSize:14,}}>{item?.name}</div>
                                            <div style={{dispaly:"flex"}}>
                                                {
                                                    item.checkList.map(item => {
                                                        return (<div style={{padding: "12px 8px"}}>
                                                            {item}
                                                        </div>)
                                                    })
                                                }
                                            </div>
                                        </div>
                                    )
                                }
                                return ""
                            })
                        }
                    </Scrollbars>
                </div>
                <div style={{
                    height:40,
                    borderTop: "1px solid #e8e8e8",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}>
                    <Button id={"againCheck"} onClick={this.onCheckBtn}>再次检测</Button>
                    <style>
                        {
                            `
                            #againCheck {
                                color: rgba(0, 0, 0, 0.65) !important;
                            }
                            `
                        }
                    </style>
                </div>
            </div>
        )
    };
    // 判定保存后是否需要检测敏感词
    checkActionDecision = (activiti,isOnlySave) => {
        let status = activiti?.options?.statusNameTemp;
        let btnName = activiti?.options?.item?.btnName;
        let needCheckStatus = this.sysConfigGetValueByKey("need.check.status.weixin","已发布");
        if (isOnlySave === "onlySave" || !activiti) {
            return (
                needCheckStatus.indexOf("暂存") > -1 ||
                needCheckStatus.indexOf("保存") > -1 ||
                needCheckStatus.indexOf("全部") > -1
            )
        }
        return (needCheckStatus && ((status && needCheckStatus.indexOf(status) > -1) || ( btnName&&needCheckStatus.indexOf(btnName) > -1)|| needCheckStatus.indexOf("全部")>-1 )) ? true : false
    };
    onCheckSave = (call,activiti,isOnlySave) => {
        // 判定是否需要敏感词检测
        if(this.checkActionDecision(activiti,isOnlySave)) {
            this.onCheck((res)=>{
                let msg = res?.msg;
                let {count,checkStatus} = this.securityCheck.getCheckResult(["count","checkStatus"]);
                switch (res?.code) {
                    case 0:
                        // 没有敏感词
                        call&&call();
                        break;
                    case 1:
                        // 检测到敏感词
                        if(activiti?.options?.statusNameTemp) {
                            Modal.confirm({
                                title: "检测到当前素材含有敏感信息",
                                content: "建议返回修改",
                                cancelText: "全部忽略并继续",
                                okText: "返回修改",
                                icon: "exclamation-circle",
                                centered:true,
                                onOk: ()=>{
                                    this.checkData = res.data;
                                    this.showCheckResultItem();
                                    this.setState({});
                                },
                                onCancel: ()=>{
                                    call&&call()
                                },
                            });
                            return false
                        } else {
                            Modal.warning({
                                title: "检测到当前素材含有敏感信息",
                                content: "建议返回修改",
                                okText: "返回修改",
                                icon: "exclamation-circle",
                                centered:true,
                                onOk: ()=>{},
                            });
                        }
                        break;
                    case -1:
                        // 检测报错
                        message.error(msg || "敏感词检测失败");
                        break;
                    default:
                        // 未知错误
                        message.warning(msg || "敏感词检测失效，无法进行异步检测");
                }
                this.checkData = res.data;
                this.showCheckResultItem();
                this.setState({});
            });
        } else {
            call&&call()
        }
    };
    onCheckBtn = () => {
        this.onCheck((res)=>{
            let msg = res?.msg;
            switch (res?.code) {
                case 0:
                    // 没有敏感词
                    message.success(msg || "未检测到敏感信息");
                    break;
                case 1:
                    // 检测到敏感词
                    message.warning(msg || "检测到敏感信息");
                    break;
                case -1:
                    // 检测报错
                    message.error(msg || "敏感词检测失败");
                    break;
                default:
                    // 未知错误
                    message.warning(msg || "敏感词检测失效，无法进行异步检测");
            }
            let {count,checkStatus} = this.securityCheck.getCheckResult(["count","checkStatus"]);
            this.checkData = res.data;
            this.showCheckResultItem();
            this.setState({});
        })
    };
    onChangeByCheck = (call) => {
        if(typeof this.securityCheck?.setCheckStatus === "function") {
            this.securityCheck.setCheckStatus("change",()=>{
                this.setState({})
            })
        }
    };
    checkData = {};// 所有图文 敏感词检测结果
    checkDataItem = {}; // 当前图文 敏感词检测结果
    countItem=0;// 当前图文 敏感词检测数据总条数
    /**
     * 根据当前所处图文，计算当前图文的敏感信息
     * @param checkKey 当前选中的图文的敏感词检测Key
     */
    showCheckResultItem = () => {
        let {checkKey} = this.state;
        this.countItem = 0;
        this.checkDataItem = {};
        if(checkKey) {
            for(let i in this.checkData) {
                if(i.indexOf(checkKey) > -1) {
                    this.checkDataItem[i] = this.checkData[i];
                    this.countItem = this.countItem + (this.checkData[i]?.length || 0)
                }
            }
        }
        let content = removeContentSecurity(this.state.content);
        if(this.checkDataItem?.["content_"+checkKey]?.length) {
            // 对敏感词进行排序，长的排前面
            this.checkDataItem["content_"+checkKey].sort((a,b)=>b.word.length-a.word.length);
            let tempData =[];
            this.checkDataItem["content_"+checkKey].forEach(check=>{
                if (!tempData.some(item=>item.word == check.word)) {
                    tempData.push(check);
                }
            })
            tempData.forEach(item=>{
                let replaceWord = addContentSecurityByText(item?.word);
                // let reg = `([>][^<]*)${item?.word}([^>]*[<])`;
                // content = content.replace(new RegExp(reg,"g"),`$1${replaceWord}$2`);
                content = this.checkWordReplace(content,item?.word,replaceWord);
            })
        }
        this.setState({content,isUpDate:true});
    };
    checkWordReplace = (content, word,replaceHtml) => {
        let newTxt = content;
        const regex = /(^|>)[^><]+?(?=$|<)/g;
        return  newTxt.replace(regex, (match) => {
            return match.replace(new RegExp(word,"g"), replaceHtml);
        });
    };
    onCheck = (call) => {
        message.destroy();
        if(!(
            (this.materialId?.length > 9)
            || (this.state.materialId  > 9)
        )) {
            message.warning("请先保存再检测");
            return false
        }
        if(typeof this.securityCheck.asyncCheck === "function") {
            this.getCheckData(({contents,data,key})=>{
                this.securityCheck.asyncCheck({contents,data,key,
                    call:(res)=>{
                        call&&call(res)
                    }
                });
            });
        } else {
            message.warning("敏感词检测失效，无法进行异步检测");
        }
    };
    getCheckData = (call) => {
        if(!(this.state.content?.length && this.state.content.trim().length)) {
            message.warning("请输入正文后再进行检测");
            return false
        }
        let contents = {};
        if(!this.state.stuffList?.length) {
            message.warning("请先创建图文再进行检测");
            return false
        }
        let storyName = "";
        this.state.stuffList.forEach((stuff,index)=>{
            if(!storyName) {
                storyName = stuff?.title
            }
            let key = stuff?.checkKey ? stuff?.checkKey : (stuff.checkKey = uuid());
            contents["title_"+key] = stuff?.title;
            contents["summary_"+key] = stuff?.summary;
            contents["content_"+key] = removeContentSecurity(stuff?.content);
        });
        let materialId = this.materialId || this.state.materialId || "";

        let data = {
            contents,
            data: {
                "id": materialId,
                "check_info_url": "/cm-sites-pms/material/getById?materialId="+materialId,
                "storyName": storyName,
                "storyStatusName": this.state.statusName || "",
                "mediaName": this.props.mediaName || "",
                "createUserName": window.currentUser?.name || "",
                "deptName": window.currentUser?.defaultInfo?.dept?.name || "",
                "createStoryUserName": this.state.currentItem?.submitterName || window.currentUser?.name || "",
                "createStorydeptName": window.currentUser?.defaultInfo?.dept?.name || "",
                "createStoryMediaName": this.state.currentItem.mediaName || this.state.mediaName,
            },
            key: materialId,
        };
        call&&call(data)
    };
    renderFooter = () => {
        return (
            <div style={{
                padding: '20px',
                display: 'flex',
                justifyContent: 'center',
                borderTop: '1px solid #e8e8e8'
            }}>
                <Button style={{marginRight: 12}} key={uuid()} type={'button'} onClick={() => {this.download()}}>下载稿件</Button>
                <ActivitiModal
                    key={this.state.activityBtnKey}
                    // ref={(ref)=>{this.ActivitiModal=ref}}
                    {
                        ...this.state.activityOption
                    }
                />
                {this.renderOtherBtn()}
                {/*<div id={uuid()} style={{display: 'flex'}}>*/}
                {/*    {this.state.btns}*/}
                {/*</div>*/}
                <SyncModal ref={ref=>this.syncModal=ref}/>
            </div>
        )
    };
    renderOtherBtn = () => {
        let actButtons = [];
        //加入保存按钮
        if (
            (()=>{
                if(this.activitiBtns && (this.activitiBtns.length > 0)){
                    let configBtns = this.sysConfigGetValueByKey("web.editor.saveBtn.mutex.activiti.btn", "撤回").split(",");
                    let result = true;
                    this.activitiBtns && this.activitiBtns.map(item=>{
                        if(configBtns.indexOf(item.name) > -1){
                            result = false;
                        }
                    });
                    return result;
                }
                return false;
            })() &&
            this.state.statusName !== '发布' && this.state.statusName !== '已发布'
        ) {
            var saveButton = <div key={uuid()} className="button_view">
                <div className="button_div" onClick={() => {
                    this.saveMaterial(null, (res) => {
                        //关闭窗口
                        if(res) {
                            this.state.materialId = res.id;
                            this.loadMaterial();
                            // this.props.onAdvance();
                        }
                    },"onlySave")
                }}><Button
                    type={"primary"}
                    style={{margin: "0 12px"}}>保存</Button></div>
            </div>;
            actButtons.push(saveButton);
        }

        //加入预览按钮
        if(this.state.statusName !== '发布' && this.state.statusName !== '已发布') {
            var previewButton = <div key={uuid()} className="button_view">
                <div className="button_div" onClick={() => {
                    this.publisAndRevertAction("preview");
                }}><Button
                    type={"primary"}
                    style={{margin: "0 12px"}}>预览</Button></div>
            </div>;
            actButtons.push(previewButton);
        }

        // 加入内容检测按钮
        let color = "unset";
        if(typeof this.securityCheck?.renderCheckBtn === "function") {
            color = this.securityCheck.renderCheckBtn({btnType:"color"});
            let btn = <div>
                <Button id={"checkBtn-toutiao"} type="primary" style={{margin:'0px 12px'}} onClick={() => {this.onCheckBtn()}}>安全检测</Button>
                <style>
                    {`
                    #checkBtn-toutiao {background-color: ${color} !important;border-color: ${color} !important;}
                `}
                </style>
            </div>;
            actButtons.push(btn)
        }

        if(this.state.showRemarks){
            var remarksButton=<Button
                type={"primary"}
                onClick={this.showRemarksCall}
                style={{margin: "0 12px"}}>查看备注</Button>;
            actButtons.push(remarksButton);
        }
        return actButtons
    };
    renderModal = () => {
        return (
            <>
                <Modal
                    title="发送到手机预览"
                    visible={this.state.visible}
                    onOk={this.previewHandleOk}
                    onCancel={this.previewHandleCancel}
                >
                    <Input ref={"weiChatCode"} placeholder="请输入微信号"/>
                    <p style={{color: '#ccc',paddingTop: '10px',marginBottom: '-15px'}}>编辑素材，请先保存后才能预览！</p>
                </Modal>
                <ChooseUserModal ref={"chooseUserModal"}/>
                <Modal
                    title="群发方式"
                    visible={this.state.publishModalVisible}
                    onOk={this.publishHandleOk}
                    onCancel={this.publishHandleCancel}
                >
                    <WeiChatTagSelect mediaCode={this.props.mediaId} ref={that => this.weiChatTagSelect = that}/>
                </Modal>
                <Modal
                    title={this.textareaModalTitle}
                    visible={this.state.textareaModalVisible}
                    onOk={this.textareaHandleOk}
                    onCancel={this.textareaHandleCancel}
                >
                    <TextArea ref={that => this.remarks = that} placeholder="请输入备注"/>
                </Modal>
            </>
        )
    };
    //正文选择
    contentChoose() {
        let currentContent = this.state.content;
        let imgAll = $(currentContent).find('img').not(".edui-upload-video").not(".edui-faked-video").not(".edui-faked-music");
        if(!(imgAll && imgAll.length))
            return  message.destroy() || message.error("正文中未找到图片！");
        this.imgChoose.showModal();
        this.setState({imgAll});
    }
    // 传正文图
    getImgChoose = (data) => {
        if(data) {
            if (this.state.stuffList.length > 0) {
                this.state.stuffList[this.state.currentItemIndex].titlePic = data;
            }
            this.setState({
                titlePic:data,
            })
        }
    };
    loadMaterial = () => {
        if (parseInt(this.state.materialId) > 0) {
            this.request({
               url: '/cm-sites-pms/material/getById',
                body: {materialId:this.state.materialId},
                callBack: (res) => {
                    this.getNeedShowButtonMaterial(res);
                    if (res.statusName === '发布') {
                        this.canEdit = false;
                    }
                    console.log("============================t",res);
                    let stuffList = res.stuffList;
                    this.state.isAdd = true;// res.isAdd ? res.isAdd : false;//是否是新增的素材现在不做限制，全部为true
                    if (stuffList.length > 0) {
                        stuffList.forEach(item=>{
                            item.checkKey=uuid() // 用做敏感词检测标识
                        });
                        let currentItem = stuffList[0];
                        this.state.currentItem = stuffList[0];
                        this.state.currentItemIndex = 0;
                        this.state.title = currentItem.title;
                        this.state.checkKey = currentItem.checkKey;
                        this.state.author = currentItem.author;
                        this.state.titlePic = currentItem.titlePic;
                        this.state.summary = currentItem.summary;
                        this.state.content = currentItem.content;
                        this.state.storyId = currentItem.storyId;
                        this.state.url = currentItem.url ? currentItem.url : '';
                        this.state.isUpDate = true;
                    }
                    let resultData = [];
                    for (let i = 0; i < res.stuffList.length; i++) {
                        resultData.push({
                            id: res.stuffList[i].id,
                            checkKey: res.stuffList[i].checkKey,
                            title: res.stuffList[i].title,
                            author: res.stuffList[i].author,
                            titlePic: res.stuffList[i].titlePic,
                            summary: res.stuffList[i].summary,
                            content: res.stuffList[i].content,
                            storyId: res.stuffList[i].storyId,
                            topicId: res.stuffList[i].topicId,
                            copyResourceId: res.stuffList[i].copyResourceId,
                            url: res.stuffList[i].url ? res.stuffList[i].url : '',
                            dataSource: 6,
                            materialId: this.state.materialId,
                            isAddTopic: res.stuffList[i].isAddTopic,
                            uid: res.stuffList[i].uid,
                        })
                    }
                    this.checkData = {};
                    this.checkDataItem = {};
                    this.countItem = 0;
                    this.showCheckResultItem();
                    this.setState({
                        stuffList: resultData,
                        statusName: res.statusName
                    })
                }
            });
        } else {
            this.state.isAdd = true;
            this.addPic();
            this.getNeedShowButtonMaterial({});
        }
    };

    /**
     * 更具稿件的id和用户角色，获取面板需要显示的流程按钮
     * @param storyId
     */
    getNeedShowButtonMaterial(material) {
        let activitiConfs = [];
        let baselConf = {
            activitiTypeEnum: activitiType_G,
            type: "WECHAT",
            mediaId: this.props.mediaId
        };
        activitiConfs.push(baselConf);
        // Activiti.util.post('/cm-sites-pms/mediaTreeActiviti/getMediaRoleByColum', JSON.stringify(activitiConfs), (data) => {
        //     if (!data) {
        //         return "没有权限";
        //     }
        //     mediaRoleColum = data;
        //     this.initAct(material);
        // });
        this.initActivitiConfig(material);
    }

    initAct(currentMaterial) {
        //新的微信流程适配
        let canDo = true;
        let that = this;
        //微信的配置信息
        let activitiConfs = [];
        let baselConf = {
            activitiTypeEnum: activitiType_G,
            type: "WECHAT",
            mediaId: this.props.mediaId,
        };
        activitiConfs.push(baselConf);
        let againFlag = false;
        againFlag = (currentMaterial && currentMaterial.statusName == "草稿");
        Activiti.createActivit({
                uuid: currentMaterial && currentMaterial.uuid ? currentMaterial.uuid : "",   //主键id
                pojoName: "material",
                userAccount: window.top.currentUser.account,
                showBtnFlag: true,
                activitiConf: activitiConfs,
                againFlag: againFlag,
                showAfterFuns: {   //按钮加载前置js

                    //撤回按钮显示前置js
                    callBackBtnShow: function (item, call) {
                        //不允许编辑
                        canDo = false;
                        call({code: 1});
                    },
                    publishCheck: function (item, call) {
                        if (mediaRoleColum.publish) {
                            call({code: 1, log: "拥有发布权限"});
                        } else {
                            call({code: 0, log: "未拥有发布权限"})
                        }
                    }
                },
                render: function () {

                },
                otherJs: {
                    callActRevert: function (activiti, buttonConf, call) {
                        activiti.terminate.call(activiti, function (res) {
                            if (res == true) {
                                activiti.options.statusNameTemp = "草稿";
                                // //如果是约稿的撤稿，需要修改 约稿人的 状态；
                                // that.callBackTxyStatus();

                                activiti.endFunction(activiti, function (res) {
                                    if (res.status == true) {
                                        message.success("流程已撤回，稿件变为草稿状态", 1, function () {
                                            activiti.submitOK();
                                        });
                                    }
                                })
                            }
                        });
                    },
                    /**
                     * 选择我自己
                     * @param activiti
                     * @param buttonConf
                     * @param call
                     */
                    chooseMe: function (activiti, buttonConf, call) {
                        let userInfo = window.top.currentUser;
                        activiti.options._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS = [{
                            id: userInfo.account,
                            name: userInfo.name
                        }];
                        call({code: 1, log: "chooseMe：下一流程 流转至当前用户！"});
                    },
                    callBackSubmiiter: function (activiti, buttonConf, call) {
                        that.callBackSubmiiter.call(that, activiti, buttonConf, call);
                        call({code: 1, log: "callBackSubmiiter"});
                    },
                    callPublish: function (activiti, buttonConf, call) {
                        if (!that.state.stuffList || that.state.stuffList.length === 0) {
                            message.warn("请至少添加一个图文");
                            that.setState({
                                loading: false
                            });
                            return;
                        }
                        that.setState({
                            publishModalVisible: true
                        });
                        that.callback = call;
                        that.isActPublish = true;
                    },
                },
                success: function (activiti) {   //对象创建成功回调

                    //重写推进前保存方法
                    activiti.afterSave = function (activiti, call) {
                        // saveDraft(activiti,"act",call);
                        that.saveMaterial.call(that, activiti, call);
                    };
                    activiti.getActivitiKey = function (activitiConf, call) {
                        activiti.post("/cm-sites-pms/mediaTreeActiviti/getByconf", JSON.stringify(activitiConf), function (res) {
                            if (res && res.activitiApp && res.activitiApp.key) {
                                call(res.activitiApp.key);
                            } else {
                                call(false);
                            }
                        }, "json")
                    };

                    //重写显批注信息
                    activiti.showRemarks = function (remarks) {
                        if (remarks) {
                            let btns = that.state.btns;

                            //加入查看备注按钮
                            var showRemarkBtn = <div style={{display: 'block'}} key={uuid()} className="button_div"
                                                     onClick={() => {
                                                         that.publisAndRevertAction('remarks');
                                                     }}><Button
                                type={"primary"}
                                style={{marginRight: "10px"}}>{"查看备注"}</Button></div>;

                            btns.push(showRemarkBtn);
                            that.setState({
                                remarksContent: remarks,
                                btns: btns,
                            });
                        }
                    };
                    //重写创建按钮的方法
                    activiti.renderButton = function (buttons = [], call) {
                        that.renderButtons(buttons, call, activiti, activitiConfs)
                    };

                    //填写备注信息
                    activiti.getText = function (data, type, callback) {
                        that.getText(data, type, callback, activiti)
                    };

                    activiti.load = {
                        start: function () {
                            window.loading.show()
                            // message.loading("处理中...");
                        },
                        end: function () {
                            window.loading.hide()
                        }
                    };
                    activiti.getChoose = function (data, type, callback) {
                        that.getChoose(data, type, callback, activiti);

                    };
                    activiti.endFunction = function (activiti, call) {  //流程推进后的回调一般用作推进后修改状态
                        let statusName = activiti.options.statusNameTemp;
                        let params = {
                            materialId: that.materialId,
                            statusName: statusName === '发布' ? "发布中" : statusName,
                            isAdd: that.state.isAdd
                        };
                        saveStatusName(params, (data) => {
                            if (data.code == 200) {
                                call({status: true, msg: data.msg});
                            } else {
                                call({status: false, msg: "流程推进后状态修改失败。"});
                            }
                        });
                    };
                    activiti.error = function (res) {     //流程推进成功后的提示点击确定的回调，一般用来关闭窗口或刷新
                        message.error(res, 1);
                    };
                    activiti.successMsg = function (res, call) {
                        message.success(res, 1, call);
                    };
                    activiti.submitOK = function (call) {
                        //关闭窗口
                        that.props.onAdvance();
                    }
                },
            }
            , function () {
                //流程初始化完成之后的回调
                if (this.buttonList && this.buttonList.length > 0 && canDo) {
                }
            });
    };

    getChoose = (data, type, callback) => {
        if (!this.state.stuffList || this.state.stuffList.length === 0) {
            message.warn("请至少添加一个图文");
            this.setState({
                loading: false
            });
            return;
        }
        this.refs.chooseUserModal.showModal(data, (accountArray) => {
            let callbackValue = {};
            callbackValue.activitiUsers = accountArray;
            callbackValue.type = type;
            callback(callbackValue);
        });
    };

    materialId = this.props.materialId;

    statusNameTemp = "";

    checkContent = (content) => {
        let newContent = content.replace(/(<(?!img|IMG).*?>)|(&nbsp;)|(\s)/g,"");
        return newContent?true:false
    };

    checkAndGetParams = async () => {
        if (!this.state.stuffList || this.state.stuffList.length === 0) {
            message.error("请至少添加一个图文！");
            window.loading.hide();
            return false;
        }
        const {stuffList, materialId,currentItemIndex} = this.state;
        for (let i = 0; i < stuffList.length; i++) {
            if (!stuffList[i].title || stuffList[i].title.trim() === '') {
                message.warning('存在图文未填写标题，请先填写标题！');
                window.loading.hide();
                return false;
            }
            if (!stuffList[i].titlePic) {
                message.warning('存在图文未上传封面，请先上传封面！');
                window.loading.hide();
                return false;
            }
            if (!stuffList[i].content || stuffList[i].content.trim() === '' || !this.checkContent(stuffList[i].content)) {
                message.warning('存在图文未填写内容，请先填写内容！');
                window.loading.hide();
                return false;
            }
            if((!stuffList[i].summary || stuffList[i].summary.trim() === '') && stuffList[i].text && (materialId === -1 || materialId == 'null' || materialId == 'undefined') ){
                stuffList[i].summary = stuffList[i].text.length > 54 ? stuffList[i].text.substr(0, 54) : stuffList[i].text;
                if(i===currentItemIndex) {
                    this.state.summary = stuffList[i].summary
                }
            }
            if (stuffList[i].url && stuffList[i].url.trim() !== '') {
                var re = new RegExp('^(http|https):\\/\\/.');
                if (!re.test(stuffList[i].url)) {
                    message.warning('第' + (i + 1) + '篇图文原文链接不正确，请修改！');
                    window.loading.hide();
                    return false;
                }
            }
            if(stuffList[i].author?.length > 8) {
                message.warning('请修改作者名称为8个字以内！');
                window.loading.hide();
                return false;
            }
        }

        let {status,newStuffList}= await this.stuffListPromise(stuffList);

      // 微信编辑器内容加密
        if (status) {
            return {
                id: (materialId.length > 1 && materialId != 'undefined' && materialId != 'null') ? materialId : null,
                mediaId: this.props.mediaId,
                stuffList: newStuffList,
                isAdd: this.state.isAdd
            };
        } else {
            this.state.stuffList = newStuffList;
            return false
        }
    };

    stuffListPromise(stuffList) {
        return new Promise((resolve, reject) => {
            this.LinkCheck.show(stuffList, (data) => {
                console.log(data);
                resolve({status: data.status, newStuffList: data.content})
            });
        });
    }

    publishData = {};

    checkForm = async (activiti, call) => {
        message.destroy();
        let params = await this.checkAndGetParams();
        if (!params) {
            return false
        }
        call&&call()
    };

    /**
     * 公众号保存
     * */
    saveMaterial = async (activiti, callback,isOnlySave) => {
        message.destroy();
        let params = await this.checkAndGetParams();
        if (!params) {
            callback && callback(false);
            return false
        }
        let url = '/cm-sites-pms/material/save';
        let newStuffList=JSON.parse(JSON.stringify(params.stuffList));
        newStuffList.map((item,index) => {
           newStuffList[index].content = base64Encode(removeContentSecurity(item.content));
        });
        params.stuffList=newStuffList;
        this.request({
            url,
            method: 'post',
            contentType: 'json',
            body: params,
            loading: activiti ? false : true,
            callBack: (res) => {
                if (res) {
                    this.materialId = res.id;
                    this.state.materialId = res.id;
                    window.loading.hide();
                    this.onCheckSave(()=>{
                        this.publishData = {
                            ...res,
                            stuffList: res.stuffList.map((item,index) => ({
                                ...item,
                                content: base64Encode(item.content),
                            }))
                        };
                        let fun = ()=>{
                            // 获取发布状态
                            let statusNameTemp = activiti && activiti.options && activiti.options.statusNameTemp || "";
                            let activitiConfName = this.sysConfigGetValueByKey("editor.activiti.publish.states", "发布,已发布");
                            if(statusNameTemp && activitiConfName.indexOf(statusNameTemp)>-1) {
                                callback && callback(res);
                                // this.publishMaterial(res,(flag)=>{
                                //     if(flag) {
                                //         callback && callback(res);
                                //     } else {
                                //         callback && callback(false);
                                //     }
                                // })
                            } else {
                                if(!activiti) {
                                    // 点了暂存按钮
                                    message.success('保存成功！');
                                }
                                callback && callback(res);
                            }
                            this.updateProcessAndData(this.publishData)
                        };

                        // 更新稿件关系
                        if(params.stuffList.some(item=>(item.afterFun && item.afterFun.length))) {
                            // 计算需要同步投稿稿件关系的数量
                            let saveRelationNum = params.stuffList.filter(item=>item.id && item.afterFun && item.afterFun.length && item.afterFun.indexOf("saveRelation")>-1);
                            saveRelationNum = saveRelationNum && saveRelationNum.length || 0;
                            let num=0;
                            params.stuffList.forEach(item=>{
                                if(item.id && item.afterFun && item.afterFun.length) {
                                    if(item.afterFun.indexOf("saveRelation")>-1) {
                                        this.updateStoryRelationByContent({
                                            body: {
                                                mediaNewsId: res.id, // 网站稿件id
                                                mediaNewsType: "material", // 网站媒体type
                                                operateType: "contribute", // contribute 点击素材中心标题 / pickUp 点击拾取器
                                                storyId: item.id, // 原稿件Id
                                            }
                                        },(flag)=>{
                                            num+=1;
                                            if(num==saveRelationNum) {
                                                // 所有需要同步关系的接口走完后继续后续的操作
                                                fun()
                                            }
                                        });
                                    }
                                }
                            });
                        } else {
                            fun()
                        }
                    },activiti,isOnlySave);
                } else {
                    message.error('保存失败！');
                    callback && callback(false);
                }
                // this.materialId = res.id;
                // if (callback) {
                //     // res.statusName = this.statusNameTemp;
                //     // res.publishTagId = this.publishTagId;
                //     $.extend(true, params, res);
                //     callback(params);
                // } else {
                //     activiti.success({msg: "保存成功！", state: true}, activiti.submitOK);
                // }
            },
            errorCallBack: (e) => {
                callback && callback(false);
                window.loading.hide();
                message.error('保存失败！');
            },
            serverVerify:{
                serverErrorCallBack:(e,data)=>{
                    if(data?.data?.id) {
                        this.materialId = data.data.id;
                        this.state.materialId = data.data.id;
                    }
                    callback && callback(false);
                    window.loading.hide();
                    message.error('保存失败！');
                },
                isShowErrorMsg:true
            },
        });
    };

    // 更新稿件关系(拾取、复制）
    updateStoryRelationByContent = (config,call) => {
        if(config) {
            if(config.body) {
                this.request({
                    url:"/cm-sites-pms/story/saveRelation",
                    method:"post",
                    body: config.body,
                    callBack: (res) => {
                        if(res) {
                            call&&call(true);
                            console.log("更新稿件关系成功！")
                        }
                    }
                })
            }
        } else {
            call&&call(false);
        }
    };

    // 更新流程稿件
    updateProcessAndData = (body) => {
        this.request({
            url: "/cm-sites-sys/process/updateProcessAndData",
            method: "post",
            contentType: "json",
            body: {
                title: body && body.stuffList && body.stuffList.length && body.stuffList[0].title,
                bizKey: body?.id,
                data: body,
            },
            callBack: (res)=>{

            }
        })
    };

    // 发布接口
    publishMaterial = (statusName, activiti, call) => {
        if(this.publishData && this.publishData.id) {
            let body = this.publishData;
            let url = '/cm-sites-pms/material/publish';
            let newStuffList=JSON.parse(JSON.stringify(body.stuffList));
            // newStuffList.map((item,index) => {
            //     newStuffList[index].content = base64Encode(item.content);
            // });
            body.stuffList=newStuffList;
            this.request({
                url,
                body,
                method: 'post',
                contentType: 'json',
                callBack: (res) => {
                    if(res) {
                        call&&call({status: true, msg: "流程推进后发布成功。"});
                    } else {
                        call&&call({status: false, msg: "流程推进后发布失败。"});
                        message.error('发布失败！');
                    }
                },
                errorCallBack: (e) => {
                    call&&call({status: false, msg: "流程推进后发布失败。"});
                    this.state.activityBtnKey = uuid();
                    this.loadMaterial();
                    window.loading.hide();
                    // this.setState({activityBtnKey:uuid()});
                    message.error('发布失败！');
                },
                serverVerify:{
                    serverErrorCallBack:(e)=>{
                        call&&call({status: false, msg: "流程推进后发布失败。"});
                        this.state.activityBtnKey = uuid();
                        this.loadMaterial();
                        window.loading.hide();
                        // this.setState({activityBtnKey:uuid()});
                        message.error('发布失败！');
                    },
                    isShowErrorMsg:true
                },
            })
        }
    };

    /**
     * 公众号修改状态
     */
    updateStatusName=(statusName, activiti, call)=> {
        let id = (this.materialId && this.materialId != '0') ? this.materialId : '';
        let params = {
            "materialId": id,
            "statusName":statusName,
        };
        this.request({
            url: '/cm-sites-pms/material/saveStatusName',
            method: 'POST',
            body: params,
            loading: false,
            callBack: function (res) {
                if (res) {
                    call&&call({status: true, msg: "流程推进后状态修改成功。"});
                } else {
                    call&&call({status: false, msg: "流程推进后状态修改失败。"});
                }
            },
            errorCallBack: function (res) {
                call&&call({status: false, msg: "流程推进后状态修改失败。"});
            }
        });
    };

    //添加备注信息
    getText = (data, type, callback, activiti) => {
        if (data) {
            this.textareaModalTitle = data.title;
        }
        this.callbackType = type;
        this.callback = callback;
        this.setState({
            textareaModalVisible: true
        });
    };

    renderButtons = (actButonsdata, call, activiti, activitiConfs) => {

        if (!actButonsdata || actButonsdata.length == 0) {
            actButonsdata = [];
        }

        let that = activiti;
        var actButtons = actButonsdata.map((item, index) => {
            //前置js， 控制按钮的显隐
            let hideStyle = {
                display: 'block'
            };
            if (item.document && item.document.lineJavaScript && item.document.lineJavaScript.afterButtonShow && that.options.showAfterFuns[item.document.lineJavaScript.afterButtonShow]) {
                hideStyle = {
                    display: 'none'
                };
                var func = eval(that.options.showAfterFuns[item.document.lineJavaScript.afterButtonShow]);
                new func(item, function (res) {
                    if (res.code > 0) {
                        // that.buttonShow(btn);
                        hideStyle = {
                            display: 'block'
                        }
                    } else if (res.code == 0) {
                        activiti.log("状态：0 ，" + item.document.lineJavaScript.afterButtonShow + ":" + res.log || res.msg);
                    } else {
                        activiti.error(item.document.lineJavaScript.afterButtonShow + ":" + res.log)
                    }
                });
            }

            //流程需要执行的其他js
            var args = [];
            if (item.document.lineJavaScript.otherJs && item.document.lineJavaScript.otherJs.split(",").length > 0) {
                var funArray = item.document.lineJavaScript.otherJs.split(",");
                $.each(funArray, function fun(i, it) {
                    var funtemp = function () {
                        var callback = Activiti.util.getCallbackFn.call(funtemp);
                        var func = that.options.otherJs[funArray[i]];
                        if (func) {
                            func.call(that, that, item, function (res) {
                                if (res) {
                                    callback.call(that, item)
                                } else {
                                    that.error(res || "执行出错！");
                                }
                            })
                        } else {
                            that.error("未找到前置js：" + funArray[i] + ",请清除浏览器缓存重试。如清理缓存后问题依然存在，请联系管理员。")
                        }
                    }
                    args.push(funtemp);
                })
            }
            args.push(function () {
                that.buttonClick.call(that, item)
            });
            const hideStyleOk = hideStyle;
            return <div key={uuid()} className="button_view" style={{...hideStyleOk}}>
                <Button
                    type={"primary"}
                    style={{marginRight: "10px"}} onClick={() => {
                    that.options.item = item;
                    //清空辅助参数
                    activiti.auditorMapTemp = {};
                    activiti.options._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS = [];
                    Activiti.util.simpleChainedFn.apply(that, args);
                }}>{item.name}</Button>
            </div>
        });

        //加入保存按钮和预览按钮；
        if (this.state.statusName !== '发布') {
            var saveButton = <div key={uuid()} className="button_view">
                <div className="button_div" onClick={() => {
                    this.saveMaterial(null, () => {
                        //关闭窗口
                        // this.props.onAdvance();
                    })
                }}><Button
                    type={"primary"}
                    style={{marginRight: "10px"}}>保存</Button></div>
            </div>;
        }
        actButtons.push(saveButton);

        var previewButton = <div key={uuid()} className="button_view">
            <div className="button_div" onClick={() => {
                this.publisAndRevertAction("preview");
            }}><Button
                type={"primary"}
                style={{marginRight: "10px"}}>预览</Button></div>
        </div>;

        actButtons.push(previewButton);
        if ((this.state.statusName == '发布' || this.state.statusName == '撤稿' || this.state.statusName == '审核通过' || this.state.statusName == '发布失败') && mediaRoleColum.edit) {
            //发布按钮
            var publishButton = <div key={uuid()} className="button_div"
                                     style={{"display": this.state.showRemarkBtnStyle}} onClick={() => {
                this.publisAndRevertAction('publish');
            }}><Button
                type={"primary"}
                style={{marginRight: "10px"}}>{"发布"}</Button></div>;
            if (this.state.statusName == '审核通过') {
                if (mediaRoleColum.publish) {
                    actButtons.push(publishButton);
                }
            }
        }
        this.setState({
            btns: actButtons,
        })
    };

    addStuff(stuff) {
        let prevState = this.state;
        for (let i = 0; i < prevState.stuffList.length; i++) {
            let oldStuff = prevState.stuffList[i];
            if (oldStuff.id === stuff.id) {
                message.error("请勿重复添加！");
                return;
            }
        }
        if (prevState.stuffList && prevState.stuffList.length >= 8) {
            message.error("最多只能添加8个图文！");
            return;
        }
        this.setState(prevState => {
            let newStuff = Object.assign({}, stuff);
            newStuff.addStuff = () => {
            };
            newStuff.openCheckedMode = true;
            prevState.stuffList.push(newStuff);
            prevState.stuffList.map((item, index) => {
                item.type = index === 0 ? "big" : "small";
            });
            return prevState;
        })
    };

    delStuff(stuff) {
        // 1、删除后当前索引不变，当前数据变为下一索引的数据
        // 2、如果下一索引无数据，当前索引减一，当前数据变为上一索引数据
        // 3、如果删完后没有数据，则数据置空
        let {currentItemIndex,stuffList} = this.state;
        stuffList.splice(currentItemIndex,1);
        // 首先判定应该取上述那种方案
        let currentItem = (()=>{
            if(stuffList?.length) {
                if(stuffList[currentItemIndex]) {
                    // 情况1
                    return stuffList[currentItemIndex]
                } else {
                    // 情况2
                    currentItemIndex--;
                    return stuffList[currentItemIndex]
                }
            } else {
                // 情况3
                currentItemIndex=-1;
                return {}
            }
        })();
        // this.state.currentItemIndex = index === -1 ? 0 : index;
        this.state.currentItemIndex = currentItemIndex;
        this.state.currentItem = currentItem;
        this.state.title = currentItem.title;
        this.state.author = currentItem.author;
        this.state.titlePic = currentItem.titlePic;
        this.state.summary = currentItem.summary;
        this.state.content = currentItem.content;
        this.state.storyId = currentItem.storyId;
        this.state.url = currentItem.title;
        this.state.checkKey = currentItem.checkKey;
        this.state.url = currentItem.title;
        this.showCheckResultItem();
        this.setState({isUpDate: true});

        // this.setState(prevState => {
        //     let newStuffList = [];
        //     let index = 0;
        //     for (let i = 0; i < prevState.stuffList.length; i++) {
        //         let oldStuff = prevState.stuffList[i];
        //         if (oldStuff.uuid !== stuff.uuid) {
        //             newStuffList.push(oldStuff);
        //         }
        //         if (oldStuff.uuid === stuff.uuid) {
        //             index = i
        //         }
        //     }
        //     prevState.stuffList = newStuffList;
        //     prevState.stuffList.map((item, index) => {
        //         item.type = index === 0 ? "big" : "small";
        //     });
        //     if (newStuffList.length === 0) {
        //         index = -1
        //     } else if (index > newStuffList.length - 1) {
        //         index = newStuffList.length - 1
        //     }
        //     prevState.currentItemIndex = index === -1 ? 0 : index;
        //     prevState.currentItem = index === -1 ? '' : prevState.stuffList[index];
        //     prevState.title = index === -1 ? '' : prevState.stuffList[index].title;
        //     prevState.author = index === -1 ? '' : prevState.stuffList[index].author;
        //     prevState.titlePic = index === -1 ? '' : prevState.stuffList[index].titlePic;
        //     prevState.summary = index === -1 ? '' : prevState.stuffList[index].summary;
        //     prevState.content = index === -1 ? '' : prevState.stuffList[index].content;
        //     prevState.url = index === -1 ? '' : prevState.stuffList[index].url;
        //     prevState.isUpDate = true
        //     return prevState;
        // });
    };

    publisAndRevertAction(type) {
        this.onClick(type);
    };

    upStuff(stuff) {
        // 当前数据不变，当前索引减一，数据组数据位置调整
        let {currentItemIndex,stuffList} = this.state;
        let newIndex = currentItemIndex - 1;
        if(newIndex === -1) {
            newIndex = stuffList.length - 1
        }
        if(newIndex === currentItemIndex) {return false}
        this.state.currentItemIndex = newIndex;
        stuffList.splice(newIndex,1,...stuffList.splice(currentItemIndex, 1 , stuffList[newIndex]));
        this.setState({});
        return false;

        // let currentIndex = -1;
        // let stuffList = JSON.parse(JSON.stringify(this.state.stuffList));
        // for (let i = 0; i < stuffList.length; i++) {
        //     let oldStuff = stuffList[i];
        //     if (oldStuff.uuid === stuff.uuid) {
        //         currentIndex = i;
        //     }
        // }
        // if (currentIndex === 0) {
        //     currentIndex = stuffList.length - 1
        // } else {
        //     currentIndex = currentIndex - 1
        // }
        // stuffList[currentItemIndex] = stuffList.splice(currentIndex, 1, stuffList[currentItemIndex])[0]
        // stuffList.map((item, index) => {
        //     item.type = index === 0 ? "big" : "small";
        // });
        // this.setState({
        //     currentItemIndex: currentIndex,
        //     isUpDate: true,
        //     stuffList,
        //     title: currentItem.title,
        //     author: currentItem.author,
        //     titlePic: currentItem.titlePic,
        //     summary: currentItem.summary,
        //     content: currentItem.content,
        //     url: currentItem.url,
        // })
    }

    downStuff(stuff) {
        // 当前数据不变，当前索引加一，数据组数据位置调整
        let {currentItemIndex,stuffList} = this.state;
        let newIndex = currentItemIndex + 1;
        if(newIndex === stuffList?.length) {
            newIndex = 0
        }
        if(newIndex === currentItemIndex) {return false}
        this.state.currentItemIndex = newIndex;
        stuffList.splice(newIndex,1,...stuffList.splice(currentItemIndex, 1 , stuffList[newIndex]));
        this.setState({});
        return false;


        // const {currentItemIndex, currentItem} = this.state;
        // let currentIndex = -1;
        // let stuffList = JSON.parse(JSON.stringify(this.state.stuffList));
        // for (let i = 0; i < stuffList.length; i++) {
        //     let oldStuff = stuffList[i];
        //     if (oldStuff.uuid === stuff.uuid) {
        //         currentIndex = i;
        //     }
        // }
        // if (currentIndex === stuffList.length - 1) {
        //     currentIndex = 0
        // } else {
        //     currentIndex = currentIndex + 1
        // }
        // stuffList[currentItemIndex] = stuffList.splice(currentIndex, 1, stuffList[currentItemIndex])[0];
        // stuffList.map((item, index) => {
        //     item.type = index === 0 ? "big" : "small";
        // });
        // this.setState({
        //     currentItemIndex: currentIndex,
        //     isUpDate: true,
        //     stuffList,
        //     title: currentItem.title,
        //     author: currentItem.author,
        //     titlePic: currentItem.titlePic,
        //     summary: currentItem.summary,
        //     content: currentItem.content,
        //     url: currentItem.url,
        // })
    }

    reloadStuff(stuff) {
        this.setState(prevState => {
            let newStuffList = [];
            for (let i = 0; i < prevState.stuffList.length; i++) {
                let oldStuff = prevState.stuffList[i];
                if (oldStuff.id === stuff.id) {
                    newStuffList.push(stuff);
                } else {
                    newStuffList.push(oldStuff);
                }
            }
            prevState.stuffList = newStuffList;
            prevState.stuffList.map((item, index) => {
                item.type = index === 0 ? "big" : "small";
            });
            return prevState
        });
        this.refs.stuffList.updateDataOne(stuff);
    }

    //预览
    preview = () => {
        this.setState({
            visible: true,
        });
    };
    // 预览确定
    previewHandleOk = e => {
        this.setState({
            visible: false,
            loading: false
        });
        const {stuffList, materialId} = this.state;
        let weiChatCode = this.refs.weiChatCode.state.value;
        let params = { materialId,weiChatCode};
        this.previewMaterial(params)
    };
    // 预览发送
    previewMaterial=(params)=>{
        this.request({
            url:'/cm-sites-pms/material/previewMaterial',
            body:params,
            callBack:(res)=>{
                if (res) {
                    message.success("已发送至手机，请查收");
                    // this.props.onAdvance();
                } else {
                    message.error(res.msg ? res.msg : '预览失败！')
                }
            },
            errorCallBack: (e) => {
                message.error(e ? e.toString() : '预览失败！')
            },
            serverVerify:{
                serverErrorCallBack:(e)=>{

                },
                isShowErrorMsg:true
            },
        })
    };
    previewHandleCancel = e => {
        this.setState({
            visible: false,
        });
    };

    publish = () => {
        this.setState({
            publishModalVisible: true
        });
    };

    publishHandleOk = () => {
        let restCount = this.weiChatTagSelect.state.restCount;
        if (restCount < 1) {
            message.warn("当前群发次数已用完");
            return;
        }
        this.setState({
            publishModalVisible: false,
        });
        const {stuffList, materialId} = this.state;
        let params = {id: materialId, mediaId: this.props.mediaId, stuffList: stuffList, isAdd: this.state.isAdd};
        let tagId = this.weiChatTagSelect.checkedTagId;
        if (!this.isActPublish) {
            publishPicAndArt(params, tagId, (res) => {
                if (res.status === 200) {
                    message.alert({msg: "发布成功！", state: true}, Activiti.submitOK);
                }
                this.setState({
                    publishModalVisible: false,
                    loading: false
                });
            })
        } else {
            this.callback({code: 1, log: "callBackPublish"});
        }
        // let tagId = this.weiChatTagSelect.checkedTagId;
        // let restCount = this.weiChatTagSelect.state.restCount;
        // if(restCount < 1){
        //     message.warn("当前群发次数已用完");
        //     return;
        // }
        // this.publishTagId = tagId;
        // this.setState({
        //     publishModalVisible : false
        // });
        // this.callback(true);
    };

    publishHandleCancel = () => {
        this.setState({
            publishModalVisible: false
        })
    };

    onClick = (type) => {
        message.destroy();
        if (!this.state.stuffList || this.state.stuffList.length === 0) {
            message.error("请至少添加一个图文！");
            return;
        }
        const {stuffList} = this.state;
        for (let i = 0; i < stuffList.length; i++) {
            if (stuffList[i].title.trim() === '') {
                message.warning('存在图文未填写标题，请先填写标题！');
                return;
            }
            if (stuffList[i].titlePic === '') {
                message.warning('存在图文未上传封面，请先上传封面！');
                return;
            }
            if (stuffList[i].content.trim() === '') {
                message.warning('存在图文未填写内容，请先填写内容！');
                return;
            }
            if (stuffList[i].url && stuffList[i].url.trim() !== '') {
                var re = new RegExp('^(http|https):\\/\\/.');
                if (!re.test(stuffList[i].url)) {
                    message.warning('第' + (i + 1) + '篇图文原文链接不正确，请修改！');
                    return;
                }
            }
        }
        if (type === "preview") {
            if(this.state.materialId && this.state.materialId.length>1 && this.state.materialId!='undefined' && this.state.materialId != 'null') {
                this.preview();
            } else {
                message.error('保存后才能预览！');
            }
        } else if (type === "publish") {
            this.publish();
        } else if (type === "remarks") {
            Modal.info({title: this.state.remarksContent})
        } else {
        }
    };

    weiChatTagSelect;

    remarks;

    canEdit = true;

    textareaHandleOk = () => {
        let remarks = this.remarks.state.value;
        if (remarks && remarks.length > 150) {
            message.error("备注信息不得超过150个字符！");
            return;
        }
        let callbackValue = {};
        callbackValue.remarks = remarks;
        callbackValue.type = this.callbackType;
        this.callback(callbackValue);
        this.setState({
            textareaModalVisible: false
        })
    };

    textareaHandleCancel = () => {
        this.setState({
            textareaModalVisible: false
        })
    };

    addPic = () => {
        //是否展示跳过按钮
        let showSkip = this.sysConfigGetValueByKey("pms.weChatPublish.skip", '0');
        if (this.state.materialId === -1 ? showSkip === '0' : showSkip === "1") {
            let currentItem = {
                //topicId:id,//选题id；可能需要素材id
                title: '',
                author: '',
                titlePic: '',
                summary: '',
                content: '',
                dataSource: 6,
                materialId: this.state.materialId,
                checkKey: uuid(), // 用做敏感词检测标识
                id: 0,
                url: '',
                storyId:'',
                isAddTopic: true,
            };
            this.state.currentItem = currentItem;
            this.state.currentItemIndex = this.state.stuffList.length;
            this.state.title = currentItem.title;
            this.state.author = currentItem.author;
            this.state.titlePic = currentItem.titlePic;
            this.state.summary = currentItem.summary;
            this.state.content = currentItem.content;
            this.state.storyId = currentItem.storyId;
            this.state.url = currentItem.url;
            this.state.checkKey = currentItem.checkKey;
            this.showCheckResultItem();
            this.setState({stuffList: [...this.state.stuffList, currentItem], isUpDate: true});
        } else {
            if (this.state.isAdd) {
                // confirm({
                //     title: '提示',
                //     content: (
                //         <div>
                //             <p>同时创建选题？</p>
                //         </div>
                //     ),
                //     okText: '确定',
                //     cancelText: '跳过',
                //     onCancel: () => {
                        let currentItem = {
                            //topicId:id,//选题id；可能需要素材id
                            title: '',
                            author: '',
                            titlePic: '',
                            summary: '',
                            content: '',
                            dataSource: 6,
                            checkKey: uuid(), // 用做敏感词检测标识
                            materialId: this.state.materialId,
                            id: 0,
                            url: '',
                            storyId:'',
                            isAddTopic: true,
                        };
                        this.state.currentItem = currentItem;
                        this.state.currentItemIndex = this.state.stuffList.length;
                        this.state.title = currentItem.title;
                        this.state.author = currentItem.author;
                        this.state.titlePic = currentItem.titlePic;
                        this.state.summary = currentItem.summary;
                        this.state.content = currentItem.content;
                        this.state.storyId = currentItem.storyId;
                        this.state.url = currentItem.url;
                        this.state.checkKey = currentItem.checkKey;
                        this.showCheckResultItem();
                        this.setState({stuffList: [...this.state.stuffList, currentItem], isUpDate: true});
                //     },
                    // onOk: () => {
                    //     this.AddTopic.changeVisible(true);
                    // },
                // });
            } else {
                let currentItem = {
                    //topicId:id,//选题id；可能需要素材id
                    title: '',
                    author: '',
                    titlePic: '',
                    summary: '',
                    content: '',
                    dataSource: 6,
                    checkKey: uuid(), // 用做敏感词检测标识
                    materialId: this.state.materialId,
                    id: 0,
                    url: '',
                    storyId:'',
                    isAddTopic: false,
                };
                this.state.currentItem = currentItem;
                this.state.currentItemIndex = this.state.stuffList.length;
                this.state.title = currentItem.title;
                this.state.author = currentItem.author;
                this.state.titlePic = currentItem.titlePic;
                this.state.summary = currentItem.summary;
                this.state.content = currentItem.content;
                this.state.storyId = currentItem.storyId;
                this.state.url = currentItem.url;
                this.state.checkKey = currentItem.checkKey;
                this.showCheckResultItem();
                this.setState({stuffList: [...this.state.stuffList, currentItem], isUpDate: true});
            }
        }
    };

    relation = () => {
        let topicId = this.state.stuffList[this.state.currentItemIndex].topicId;
        if (topicId) {
            Modal.confirm({
                title: '请确认是否取消关联选题？',
                content: '',
                okText: '确认',
                cancelText: '取消',
                onCancel: () => {
                },
                onOk: () => {
                    let stuffList = this.state.stuffList;
                    stuffList[this.state.currentItemIndex].topicName = '';
                    stuffList[this.state.currentItemIndex].topicId = 0;
                    this.setState({
                        stuffList
                    })
                }
            })
        } else {
            this.SelectManuscriptPool.showTask({taskTitle: '关联选题', topBtn: true})
        }
    };

    //点击每一项
    itemClick(item, index) {
        this.state.currentItem = item;
        this.state.currentItemIndex = index;
        this.state.title = item.title;
        this.state.author = item.author;
        this.state.titlePic = item.titlePic;
        this.state.summary = item.summary;
        this.state.content = item.content;
        this.state.storyId = item.storyId;
        this.state.checkKey = item.checkKey;
        this.state.url = item.url;
        this.showCheckResultItem();
        this.setState({isUpDate: true});
        console.log('当前点击的item', item)
    }

    //创建图文
    createTopic(data) {
        //这块代码不需要在动了选题id 需要对应字段
        //let stuffList = [];
        let currentItem = {
            //topicId:id,//选题id；可能需要素材id
            title: '',
            author: '',
            titlePic: '',
            summary: '',
            content: '',
            // topicId: data.id,
            topicName: data.tsName,
            topicId: data.id,
            dataSource: 6,
            materialId: this.state.materialId,
            id: 0,
            url: '',
            storyId:'',
            isAddTopic: true,
        };
        this.state.currentItem = currentItem;
        this.state.currentItemIndex = this.state.stuffList.length;
        this.state.title = currentItem.title;
        this.state.author = currentItem.author;
        this.state.titlePic = currentItem.titlePic;
        this.state.summary = currentItem.summary;
        this.state.content = currentItem.content;
        this.state.storyId = currentItem.storyId;
        this.state.url = currentItem.url;
        this.setState({stuffList: [...this.state.stuffList, currentItem], isUpDate: true});
    }

    //选择图文
    chooseTopic = (selectItem) => {
        let currentItem = {
            title: selectItem.title,//对应标题
            author: selectItem.author,//对应作者
            titlePic: selectItem.titlePic,//标题图
            summary: selectItem.summary,//描述
            content: this.filterContent(selectItem.content),//内容
            copyResourceId: selectItem.id,
            dataSource: 6,
            checkKey: uuid(), // 用做敏感词检测标识
            materialId: this.state.materialId,
            storyId: selectItem.storyId,
            url: '',
            isAddTopic: false,
        };
        // this.state.stuffList.push(currentItem);
        this.state.currentItem = currentItem;
        this.state.currentItemIndex = this.state.stuffList.length;
        this.state.title = currentItem.title;
        this.state.author = currentItem.author;
        this.state.titlePic = currentItem.titlePic;
        this.state.summary = currentItem.summary;
        this.state.content = currentItem.content;
        this.state.storyId = currentItem.storyId;
        this.state.url = currentItem.url;
        this.state.checkKey = currentItem.checkKey;
        this.showCheckResultItem();
        this.setState({stuffList: [...this.state.stuffList, currentItem], isUpDate: true});
    }

    filterContent = (content) => {
        if(content) {
            // 过滤视频音频标签，以及以图片形式存储的视频音频标签（video-src   alias-label="video"）
            let regStr =
                "(<\/?video.*?>)" +
                "|(<\/?audio.*?>)" +
                "|(<\/?[^>]*alias-label=\"video\".*?>)" +
                "|(<\/?[^>]*alias-label=\"audio\".*?>)" +
                "|(<\/?[^>]*video-src=.*?>)" +
                "|(<\/?[^>]*audio-src=.*?>)"
            let reg = new RegExp(regStr,"g");
            let newContent = content.replace(reg,"");
            return newContent
        } else {
            return content
        }
    };

    // 拾取图文
    synthesizer = (stuffList) => {
        stuffList.forEach(item => {
            item.checkKey = uuid();// 用做敏感词检测标识
        });
        this.state.checkKey = stuffList[0].checkKey;
        let currentItem = stuffList[0];
        this.state.currentItem = currentItem;
        this.state.currentItemIndex = 0;
        this.state.title = currentItem.title;
        this.state.author = currentItem.author;
        this.state.titlePic = currentItem.titlePic;
        this.state.summary = currentItem.summary;
        this.state.content = currentItem.content;
        this.state.storyId = currentItem.storyId;
        this.state.url = currentItem.url;
        this.showCheckResultItem();
        this.setState({stuffList, isUpDate: true});
        this.getNeedShowButtonMaterial({});
    };

    handleChange = info => {
        if (info.file.status === 'uploading') {
            this.setState({loading: true});
            return;
        }
        if (info.file.status === 'done') {
            if(info.file.response && info.file.response.data){
                //分片上传是走的自己封装的接口 所以返回值只有data
                //直接上传走的是antd的接口，所以返回值还有一个data属性包裹着的。这里主要是兼容两种返回值
                info.file.response = {...info.file.response.data, ...info.file.response};
            }
            let fileInfo = info.file.response;
            if (this.state.stuffList.length > 0) {
                this.state.stuffList[this.state.currentItemIndex].titlePic = fileInfo.path;
            }
            this.setState({
                titlePic: fileInfo.path,
                loading: false,
            })
        }
    };

    onScroll = e => {
        let currentPosition = this.scrollRef.getScrollTop();
        if (currentPosition > 0) {
            this.scrollRef && this.scrollRef.scrollToBottom();
            this.setState({scrollDown: true})
        }
        console.log(currentPosition)
    };

    download() {
        if(this.state.materialId && this.state.materialId.length>1 && this.state.materialId!='undefined' && this.state.materialId != 'null') {
            this.request({
                url: "/cm-sites-pms/material/download",
                body: {
                    materialId: this.state.materialId,
                    // index:1
                },
                method: "downloadPost",
                callBack: (res) => {
                    if(res){
                        message.success("下载成功")
                    }
                },
            })
        } else {
            message.info("先保存稿件才能下载")
        }
        // let params = {
        //     id: this.state.materialId,
        //     mediaId: this.props.mediaId,
        //     stuffList: this.state.stuffList,
        //     isAdd: this.state.isAdd
        // };
        // downloadMaterial(params, (res) => {
        //     let blob = new Blob([res], {type: "application/zip"});
        //     if (Utils.isIE()) {
        //         window.navigator.msSaveOrOpenBlob(blob, '微信素材.zip')
        //     } else {
        //         let url = window.URL.createObjectURL(blob);
        //         const link = document.createElement("a"); // 创建a标签
        //         link.href = url;
        //         let date = new Date();
        //         link.download = "微信素材"; // 重命名文件
        //         link.click();
        //         URL.revokeObjectURL(url);
        //     }
        // });
    }
    // 查看备注
    showRemarksCall = () =>{
        let that = this;
        that.syncModal.confirm({
            title: "备注",
            width: 400,
            content: <TextArea value={that.state.remarks} placeholder={"请输入"} maxLength={200} rows={2}
                               style={{width: 350, height: 64, fontSize: 14}}
                               ref={(remarksTextArea) => that.remarksTextArea = remarksTextArea}/>,
            okText: "确定",
            cancelText: "取消",
            onOk: () => {
                that.syncModal.destroy();
            },
            footer: <Button onClick={()=>{that.syncModal.destroy();}}>关闭</Button>,
            onCancel: () => {
                that.syncModal.destroy();
            }
        });
    }
}

EditMaterial.defaultProps = {
    onAdvance: () => {
    }
};
function mapStateToProps(state) {
    return {
        config: state.systemReducer.config,
        currentUser: state.systemReducer.currentUser,
    }
}

export default connect(mapStateToProps)(EditMaterial);


